import util from '../../lib/util';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from "../find";
import Expense from '../../entities/expense';
import Matter from '../../entities/matter';
import Invoice from '../../entities/invoice';

/*
 * Delete/nullify anywhere this expense is used in other entities
 *
 * @param {Expense} expense
 */
export function deleteExpense(expense: Expense, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = expense.id;
    }
    /* Simple delete usages */
        
    store.getState().matters
        .getMappingFor('expenseId', expense.id)
        .filter(matterTemp => matterTemp.status !== 'D')
        .forEach(matterTemp => {
            const _matter = matterTemp.clone();
            _matter.status =  'U';
            _matter.addedOn = newHRTimestamp();
            _matter.importSource = targetImportSource;
            _matter.importId = mergeId;

            _matter.expenses = _matter.expenses?.filter(id => id !== expense.id) || [];
            store.dispatch(Actions.MatterActions.saveMatterQueue(_matter));
        });

    store.getState().invoices
        .getMappingFor('expenseId', expense.id)
        .filter(invoiceTemp => invoiceTemp.status !== 'D')
        .forEach(invoiceTemp => {
            const _invoice = invoiceTemp.clone();
            _invoice.status =  'U';
            _invoice.addedOn = newHRTimestamp();
            _invoice.importSource = targetImportSource;
            _invoice.importId = mergeId;

            _invoice.expenseIds = _invoice.expenseIds?.filter(id => id !== expense.id) || [];
            store.dispatch(Actions.InvoiceActions.saveInvoiceQueue(_invoice));
        });

    /* Remove the actual expense */
    expense.status = 'D';
    expense.addedOn = newHRTimestamp();
    expense.addedBy = getCurrentUserId();
    expense.importSource = targetImportSource;
    expense.importId = mergeId;
    store.dispatch(Actions.ExpenseActions.removeExpenseQueue(expense));
    
}

/*
 * Replace anywhere this expense is used in other entities.
 *
 * @param {Expense} expense
 * @param {Expense} replaceWith
 * @return {Expense} - Expense will have refs stripped away
 */
export function replaceExpense(expense: Expense, replaceWith: Expense, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = expense.id;
    }
    /* Simple replace usages */
        
    store.getState().matters
        .getMappingFor('expenseId', expense.id)
        .filter(matterTemp => matterTemp.status !== 'D')
        .forEach(matterTemp => {
            const _matter = matterTemp.clone();
            _matter.status =  'U';
            _matter.addedOn = newHRTimestamp();
            _matter.importSource = targetImportSource;
            _matter.importId = mergeId;

            _matter.expenses = _matter.expenses?.map(id => (id === expense.id) ? replaceWith.id : id) || [];
            store.dispatch(Actions.MatterActions.saveMatterQueue(_matter));
        });

    store.getState().invoices
        .getMappingFor('expenseId', expense.id)
        .filter(invoiceTemp => invoiceTemp.status !== 'D')
        .forEach(invoiceTemp => {
            const _invoice = invoiceTemp.clone();
            _invoice.status =  'U';
            _invoice.addedOn = newHRTimestamp();
            _invoice.importSource = targetImportSource;
            _invoice.importId = mergeId;

            _invoice.expenseIds = _invoice.expenseIds?.map(id => (id === expense.id) ? replaceWith.id : id) || [];
            store.dispatch(Actions.InvoiceActions.saveInvoiceQueue(_invoice));
        });

    return expense;
}

/*
 * Determine the impact of deleting this expense from other entities
 *
 * @param {Expense} expense
 * @return {Array.<{count: number, entity: string}>} - a list of impacted entities, along with a count of impacted entities
 */
export function deleteImpactExpense(expense: Expense) {
    const impacts: string[] = [];
    const state = store.getState();
    
    /* Simple delete usages */
        
    const matterExpensesImpact = state.matters
          .getMappingFor('expenseId', expense.id)
          .filter(matter => matter.status !== 'D');

    matterExpensesImpact.forEach(() => impacts.push('matters'));

    const invoiceExpenseIdsImpact = state.invoices
          .getMappingFor('expenseId', expense.id)
          .filter(invoice => invoice.status !== 'D');

    invoiceExpenseIdsImpact.forEach(() => impacts.push('invoices'));

    return util.countDistinct(impacts);
}